import { Modal } from 'antd';
import styles from './styles.module.scss';
import Warning from '../../../../assets/warning.png';

interface Props {
	open: boolean;
	onClose: () => void;
}

const ChangeOfEmailModal = ({ open, onClose }: Props) => {
	return (
		<Modal open={open} footer={null} onCancel={onClose}>
			<section className={styles.section}>
				<img src={Warning} alt='warning' className={styles.img} />
				<h4 className={styles.heading}>No Alternative Email</h4>
				<p className={styles.para}>
					To change the email linked to your <br />
					account, you must first provide your
					<br /> alternative email.
				</p>
			</section>
		</Modal>
	);
};

export default ChangeOfEmailModal;
